// Validation runs when the coach hits "Generate report". On a long form the
// failing field can be far off-screen, so we scroll/focus the earliest one.
// This returns the error key that appears first in the form's visual order.

const THRESHOLD_KEYS = ['t1', 't2'] as const;
const THRESHOLD_FIELDS = ['intensity', 'pace', 'hr', 'hr_pct_max'] as const;
const ZONE_FIELDS = ['intensity', 'hr'] as const;
const VO2_FIELDS = [
  'max_output',
  'vo2max',
  'max_hr',
  'ventilation',
  'tidal_volume',
  'resp_frequency',
] as const;
const ZONE_COUNT = 5;

// Order mirrors the section order rendered in LactateTestForm:
// Thresholds → Measured HRmax → Zone boundaries → VO₂max.
const FIELD_ORDER: string[] = [
  ...THRESHOLD_KEYS.flatMap((k) => THRESHOLD_FIELDS.map((f) => `thresholds.${k}.${f}`)),
  'measured_hr_max',
  ...Array.from({ length: ZONE_COUNT }).flatMap((_, i) =>
    ZONE_FIELDS.map((f) => `zone_boundaries.${i}.${f}`)
  ),
  ...VO2_FIELDS.map((f) => `vo2.${f}`),
];

export function firstErrorField(errors: Record<string, string>): string | null {
  for (const key of FIELD_ORDER) {
    if (errors[key]) return key;
  }
  // Any key outside the known order (defensive) — surface it rather than nothing.
  const remaining = Object.keys(errors);
  return remaining.length > 0 ? remaining[0] : null;
}
